import { useMeStore } from '@/stores/me'
import type { GtmEventParameters } from '@/types/gtmEvents'
import { RequestStatus } from '@/utils/restStore'
import { event } from 'vue-gtag'

export const sendGtmEvent = (params: GtmEventParameters) => {
  const meStore = useMeStore()
  const value = params.value || {}
  if (meStore.me.status === RequestStatus.RequestLoaded) value['user_id'] = meStore.me.data.uuid

  event(params.name, {
    event_category: params.category,
    event_label: params.label,
    value: value
  })
}
